import { DownArrow, UpArrow } from "components/atoms/Icon";
import Tooltip from "components/atoms/Tooltip";
import { Header, Paragraph } from "components/atoms/Typography";
import { ReactNode } from "react";
import { formatPercentage } from "utils/formatting";

interface IncreaseDecreasePercentageProps {
    value: number;
    isHeader?: boolean;
    invertedColor?: boolean;
    tooltipElement?: string | ReactNode;
}

export function IncreaseDecreasePercentage({
    value,
    isHeader = false,
    invertedColor = false,
    tooltipElement,
}: IncreaseDecreasePercentageProps) {
    const isNegative = value > 0;
    const isNeutral = Math.round(value) === 0;
    const isPositive = value < 0;

    let color;

    if (invertedColor) {
        if (isNegative) color = "var(--audette-content-positive)";
        if (isPositive) color = "var(--audette-content-negative)";
    } else {
        if (isNegative) color = "var(--audette-content-negative)";
        if (isPositive) color = "var(--audette-content-positive)";
    }

    if (isNeutral) color = "var(--audette-gray-500)";

    const formattedValue = `${formatPercentage(Math.abs(value))}%`;

    return (
        <div style={{ display: "flex", gap: "10px" }}>
            {tooltipElement && <Tooltip tooltipBody={tooltipElement} />}

            <div style={{ color, textAlign: "center" }} className="card__increase-decrease-percentage">
                {isPositive || isNeutral ? <DownArrow color={color} /> : <UpArrow color={color} />}
                {/* Conditionally rendering Header or Paragraph based on isHeader */}
                {isHeader ? (
                    <Header size="small" style={{ color }}>
                        {formattedValue}
                    </Header>
                ) : (
                    <Paragraph size="small" style={{ color }}>
                        {formattedValue}
                    </Paragraph>
                )}
            </div>
        </div>
    );
}
